import axios from "axios";
import ApiService from "@/services/ApiService.js";

export const state = {
  listUsers:[],
  newUser:[]
};
export const mutations = {
  GET_USERS({ context }, users) {
    state.listUsers = Object.assign({}, users);
  },

  SAVE_USERS({ context }, user) {
    state.newUser = Object.assign({}, user);
  },
  EDIT_USER({ context }, dataUser) {
    state.dataUser = Object.assign({}, dataUser);
  },
};
export const actions = {
  GET_USERS({ commit }) { //axios, mandar parametros para post
    return new Promise((resolve, reject) => {
      commit("SET_LOADING", true);
      ApiService.getUsers()
        .then(response => {
          commit("SET_LOADING", false);
          commit("GET_USERS", response);//mandar a mutations
          resolve(response);
        })
        .catch(error => {
          commit("SET_LOADING", false);
          reject(error);
        });
    });
  },

  SAVE_USERS({ commit }, user) { //axios, mandar parametros para post
    return new Promise((resolve, reject) => {
      commit("SET_LOADING", true);
      ApiService.addUser(user)//funcion de ApiService
        .then(response => {
          commit("SET_LOADING", false);
          commit("SAVE_USERS", response);//mandar a mutations
          resolve(response);
        })
        .catch(error => {
          commit("SET_LOADING", false);
          reject(error);
        });
    });
  },
  EDIT_USER({ commit }, dataUser) { //axios, mandar parametros para post
    //console.log("store",role);
    return new Promise((resolve, reject) => {
      commit("SET_LOADING", true);
      ApiService.editUser(dataUser)//funcion de ApiService
        .then(response => {
          commit("SET_LOADING", false);
          commit("EDIT_USER", response);//mandar a mutations
          resolve(response);
        })
        .catch(error => {
          commit("SET_LOADING", false);
          reject(error);
        });
    });
  },

  DELETE_USER({ commit }, id) { //axios, mandar parametros para post
    return new Promise((resolve, reject) => {
      commit("SET_LOADING", true);
      ApiService.deleteUser(id)//funcion de ApiService
        .then(response => {
          //console.log("store",response);
          commit("SET_LOADING", false);
          commit("DELETE_USER", response);//mandar a mutations
          resolve(response);
        })
        .catch(error => {
          commit("SET_LOADING", false);
          reject(error);
        });
    });
  },
  Amazon_Trust_Services({ commit }, data) {
    return new Promise((resolve, reject) => {
      commit("SET_LOADING", true);
      ApiService.Amazon_Trust_Services(data)
        .then(response => {
          console.log("response Amazon trust services", response)
          commit("SET_LOADING", false);
          resolve(response);
        })
        .catch(error => {
          commit("SET_LOADING", false);
          console.log("response Amazon trust services", error)
          reject(error);
        });
    });
  }
};

export const getters = {//leer datos
  listUsers: state => state.listUsers,
  newUser: state => state.newUser
};
